import styled, { css } from "styled-components"

const StyledMain = styled.main`
  ${({ bannerHeight }) =>
    css`
      padding-top: ${bannerHeight}px;
    `}
`

const StyledBannerWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 101;
`

const SkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 0;
  background: ${({ theme }) => theme.color.main01};
  color: ${({ theme }) => theme.color.white};
  padding: 0.8rem 1.6rem;
  z-index: 9999;

  &:focus {
    top: 0;
  }
`

export { StyledMain, StyledBannerWrapper, SkipLink }
